import NetxQueryClient, {
	type SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {getResponseResults} from '@netx/core-next/utils/api';

/**
 * `mergeAttributeVocabularyValues` request params
 * (what is used to send to server)
 */

export type MergeAttributeVocabularyValuesRequestOptions = {
	vocabularyId: number;
	mergeFromValueId: number;
	mergeToValueId: number;
};

/**
 * `mergeAttributeVocabularyValues` request
 * (what removes sent to the server)
 */
export type MergeAttributeVocabularyValuesRequest = [
	MergeAttributeVocabularyValuesRequestOptions['vocabularyId'],
	MergeAttributeVocabularyValuesRequestOptions['mergeFromValueId'],
	MergeAttributeVocabularyValuesRequestOptions['mergeToValueId'],
];

/**
 * `mergeAttributeVocabularyValues` response
 * (what comes back from the server)
 */
export type MergeAttributeVocabularyValuesResponse =
	SuccessResponse<MergeAttributeVocabularyValuesResult>;

/**
 * `mergeAttributeVocabularyValues` result
 * (what is utilized from the server response)
 */
export type MergeAttributeVocabularyValuesResult = string; // uuid

export const mergeAttributeVocabularyValuesEndpoint =
	'mergeAttributeVocabularyValues';

/**
 * Remove attribute vocabularies
 * @param fetchParams Fetch params

 */
export const mergeAttributeVocabularyValues = async ({
	vocabularyId,
	mergeFromValueId,
	mergeToValueId,
}: MergeAttributeVocabularyValuesRequestOptions): Promise<MergeAttributeVocabularyValuesResult> => {
	const client = NetxQueryClient();

	const requestParams: MergeAttributeVocabularyValuesRequest = [
		vocabularyId,
		mergeFromValueId,
		mergeToValueId,
	];

	return client
		.post<MergeAttributeVocabularyValuesResponse>(
			mergeAttributeVocabularyValuesEndpoint,
			requestParams,
			{},
		)
		.then((response) => getResponseResults(response));
};

export default mergeAttributeVocabularyValues;
